import React, { ReactElement } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputText, InputTextProps } from "primereact/inputtext";

interface InputProps extends InputTextProps {
  label: string;
  name: string;
  value: any;
  warn: string;
  isRequired?: boolean;
  extendedlabel?: string | ReactElement;
}
export default function Input(props: InputProps) {
  const { name, label, warn, extendedlabel, isRequired, ...rest } = props;
  const { setFieldTouched, setFieldValue } = useFormikContext();

  return (
    <div className="flex flex-column w-full py-2" id={name.split(".").pop()}>
      {label && !props?.hidden && (
        <label className={isRequired ? "isRequired" : ""} htmlFor={name} id={name.split(".").pop()}>
          {" "}
          {label}
        </label>
      )}
      {extendedlabel && (
        <div className="helpertext">
          <i>{extendedlabel}</i>
        </div>
      )}
      <Field
        alt={name}
        name={name}
        {...rest}
        value={rest.value ?? ""}
        as={InputText}
        onChange={(e: any) => {
          setFieldTouched(name, true, true);
          setFieldValue(name, e.target.value);
        }}
      />
      {warn && <div className=" text-left fieldadv">{warn}</div>}

      <ErrorMessage name={name ?? ""} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
